module.exports = __webpack_public_path__ + "img/gravatar.b978a474.png";